<template>
  <div
  class="modal right fade trader-info send-email addfltrmodal"
  id="trader-info"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"       
  >
  <div class="modal-dialog modal-dialog-centered modal-xl" style="max-width: 1300px;" role="document">
      <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title">Send Email</h5>
          <button type="button" class="close"  @click="$emit('close')">
          <span aria-hidden="true">&times;</span>
          </button>
      </div>
      <div class="modal-body">
        <div v-if="loadingInit" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
        <div class="d-flex" style="justify-content: space-between;height: 550px;">
          <div style="flex: 1; text-align: center;">
            <div v-if="currentCustomer">
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
              <div class="d-flex" style="justify-content: space-between;">
                <button style="height: fit-content;" type="button" class="btn btn-info btn-sm" @click="prevCustomer()" :disabled="isFirstCustomer"><i class="fa fa-arrow-left" aria-hidden="true"></i> Previous</button>
                  <!-- <h3 class="text-info">{{ currentIndex+1 }} of {{ customerOffers.length }}</h3> -->
                  <div class="d-flex mb-3" style="flex-direction: column;" >
                    <!-- <span class="text-info"><h3>{{ currentCustomer.customerName }}</h3></span> -->
                    <!-- <span class="d-flex"><span>Filter Matched :</span>  <h4 class="text-warning"> {{ currentCustomer.matchedFilterNames }}</h4></span> -->
                  </div>
                <button style="height: fit-content;" type="button" class="btn btn-info btn-sm" @click="nextCustomer()" :disabled="isLastCustomer">Next <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
              <div class="mt-4" style="
                            display: flex;
                            justify-content: space-between;
                        ">
                <!-- <h5 class="text-left">{{ currentCustomer.customerName }}</h5> -->
                <div style="min-width: 230px;"  v-if="currentCustomer.isCustomerNotFound">
                        <label for="accountno required">Customer * </label>
                          <multiselect 
                            v-model="selectedCustomer" 
                            @select="customerSelected()"
                            placeholder="Select Customer" 
                            :options="customerList" 
                            :multiple="false" 
                            label="customerFullName" 
                            track-by="id" >
                          </multiselect>
                    </div>
                    <div style="min-width: 230px;" v-if="currentCustomer.isCustomerNotFound">
                      <label for="accountno required">Customer Email * </label>
                      <select @change="clearGeneratedEmail()" class="form-control" id="exampleFormControlSelect"  v-model="selectedCustomerEmail">
                              <option value>Select</option>
                              <option
                              v-for="email in customerEmailOptions"
                              :key="email"
                              v-bind:value="email"
                            >{{email}}</option>
                            </select>
                          <!-- <multiselect 
                            v-model="selectedCustomerEmail" 
                            placeholder="Select Customer Email" 
                            :options="customerEmailOptions" 
                            :multiple="false" 
                             >
                          </multiselect> -->
                    </div>
                    <div  v-if="!currentCustomer.isCustomerNotFound">
                        <label for="accountno required">Customer *</label>
                        <h5 class="mt-2 text-warning">{{ currentCustomer.customerName }}</h5>

                         
                    </div>
                    <div style="min-width: 230px;" v-if="!currentCustomer.isCustomerNotFound">
                        <label for="accountno required">Customer Email * </label>
                        <select @change="clearGeneratedEmail()" class="form-control" id="exampleFormControlSelect"  v-model="selectedCustomerEmail">
                              <option value>Select</option>
                              <option
                              v-for="email in currentCustomer.customerEmails"
                              :key="email"
                              v-bind:value="email"
                            >{{email}}</option>
                            </select>
                          <!-- <multiselect 
                            v-model="selectedCustomerEmail" 
                            placeholder="Select Customer Email" 
                            :options="currentCustomer.customerEmails" 
                            :multiple="false" 
                             >
                          </multiselect> -->
                    </div>
                <div>
                  <div style="width:100px">
                        <div  >
                          <label for="accountno required">Spread </label>
                            <input @input="applySpread"   type="number" class="form-control" placeholder="" v-model="spread">
                        </div>
                    </div>
                </div>
              </div>
             
              <div >
                <div class="hint-color" style="margin-left: auto; margin-top: 15px; margin-bottom: 15px; justify-content: end;" >
                  <div>
                    <span class="hint mr-3" data-toggle="tooltip" data-placement="left"  title=" Alternate offers ">
                      <i class="fa fa-info-circle" style="color: #b4b4b4;"></i>
                    </span>
                     <span class="hint mr-3" data-toggle="tooltip" data-placement="left"  title="Ims offers ">
                      <i class="fa fa-info-circle" style="color :rgb(255 190 68 / 42%) "></i>
                    </span>
                     <span class="hint mr-3" data-toggle="tooltip" data-placement="left"  title="Deleted offers">
                      <i class="fa fa-info-circle" style="color: rgb(255 147 147);"></i>
                    </span>
                  </div>
                  <button @click="addCusipOffer()" style="height: 30px;margin-top: 5px;" class="btn btn-sm btn-info" >Add Offer</button>

                  </div>
                <!-- <div class="float-right mt-2 mb-2 mr-2 cursor-pointer">
                  <button class="btn btn-sm btn-info" >Add Offer</button>
                  
                </div> -->
                <div style="max-height: 520px; overflow-y: scroll;">
                <table class="table align-items-center table-flush table-hover bidtbl">
                      <thead class="thead-light psticky">
                      <tr>
                          <th scope="col" class="text-center">CUSIP</th>
                          <th scope="col" class="text-center">SOURCE</th>
                          <th scope="col" class="text-center">PRICE</th>
                          <th scope="col" class="text-center">QTY</th>
                          <th scope="col" class="text-center">MIN QTY</th>
                          <th scope="col" class="text-center">FILTER</th>
                          <th scope="col" class="text-left">SPREAD</th>
                          <th scope="col" class="text-right">ACTION</th>
                      </tr>
                      </thead>
                      <tbody>
                      <!-- <tr v-if="currentCustomer.customerOffers.length == 0 && !loading">
                          <td><p >No data available</p>
                          </td>
                      </tr> -->
                      <tr v-for="(offer,index) in currentCustomer.customerOffers" 
                          :key="offer.id" 
                          v-bind:class="{
                            'row-highlight-red': deletedOfferList.includes(offer.id),
                            'row-highlight-orange': offer.isIMSofferSelect && !deletedOfferList.includes(offer.id),
                            'row-highlight-grey': alternateOfferList.includes(offer.id) && !deletedOfferList.includes(offer.id) && !offer.isIMSofferSelect
                          }">
                          <td><span>{{offer.cusip}}</span></td>
                          <td><span>{{offer.isIMSofferSelect ? 'IMS' : 'FEED'}}</span></td>
                          <td><span>{{offer.isIMSofferSelect ? (offer.imsOfferPrice) : (offer.askPx)}}</span></td>
                          <td><span>{{offer.isIMSofferSelect ? (offer.imsOfferQty) : (offer.askQty)}}</span></td>
                          <td><span>{{offer.isIMSofferSelect ? (offer.imsOfferMinQty || 'N/A') : (offer.minQty || 'N/A')}} </span></td>
                          <td class="text-wrap" style="word-break: break-all;"><span>{{offer.matchedFilters.filter(filter => currentCustomer.matchedFilterNamesArray.includes(filter)).toString()}}</span></td>
                          <td class="text-left"><span><input @input="clearGeneratedEmail" style="margin: 0px;" type="number" class="form-control"  v-model="offer.spread"/></span></td>
                          <td class="text-right">
                            <!-- <div class="dropdown">
                              <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  <i class="fas fa-ellipsis-v"></i>
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                <button 
                                  v-if="offer.offerCount > 1 || deletedOfferList.includes(offer.id)" 
                                  @click="showChangeOfferModal(offer)"
                                  class="dropdown-item" type="button">
                                  Change Offer
                                </button>
                                <button  
                                  @click="deleteOffer(index)"
                                  class="dropdown-item" type="button">
                                  Delete
                                </button>
                              </div>
                            </div> -->
                          <button
                                  v-if="(offer.offerCount > 1 || alternateOfferList.includes(offer.id)) && !deletedOfferList.includes(offer.id)"
                                  @click="showChangeOfferModal(offer)"
                                  title="Change Offer"
                                  class="btn btn-outline-info btn-sm mr-2"
                                  style="background-color: #11cdef;"
                                >
                                  <i class="fa fa-retweet" style="background-color: #11cdef ; color: #fff !important;"></i>
                                </button>
                                <button
                                  v-if="!deletedOfferList.includes(offer.id)"
                                  @click="deleteOffer(index)"
                                  title="Delete"
                                  class="btn btn-outline-danger btn-sm"
                                >
                                  <i class="far fa-trash-alt"></i>
                                </button>
                            </td>

                      </tr>
                      <tr v-for="(offer,index) in manualEntries" :key="index">
                        <td><span>{{offer.cusip}}</span></td>
                        <td><span></span></td>
                        <td><span>{{offer.price}}</span></td>
                        <td><span>{{offer.qty}}</span></td>
                        <td><span></span></td>
                        <td><span></span></td>
                        <td><span></span></td>
                        <td class="text-right">
                          <button
                                  @click="deleteManualEntri(index)"
                                  title="Delete"
                                  class="btn btn-outline-danger btn-sm"
                                >
                                  <i class="far fa-trash-alt"></i>
                                </button>
                        </td>

                      </tr>
                      </tbody>
                </table>
                </div>
              </div>
              <div class="form-row">
             
                    
              </div>
              <div class="form-row" style="justify-content: center;">
                <div class="mt-4" v-if="currentCustomer.customerOffers.length">
                  <button :disabled="loading || !selectedCustomerEmail || currentCustomer.customerOffers.length == 0" type="button" @click="generateEmail(currentCustomer)"  class="btn btn-success btn-sm">GENERATE EMAIL</button>
                </div>
                <div class="mt-4" v-if="currentCustomer.customerOffers.length == 0 && manualEntries.length">
                  <button :disabled="loading || !selectedCustomerEmail" type="button" @click="generateEmail(currentCustomer)"  class="btn btn-success btn-sm">GENERATE EMAIL</button>
                </div>
                
              </div>
            </div>
          </div>
          <div style="width: 1px; background-color: #ccc; margin: 0 10px;"></div>
          <div style="flex: 1;">
            <div class="text-right">
              <button :disabled="!isEmailGenerated || loading" type="button" @click="sendToCustomer(currentCustomer)"  class="btn btn-warning btn-sm mb-2">SEND TO CUSTOMER</button>
            </div>
            <div  v-if="isEmailGenerated">
              <div class="row">
                <div class="col-md-6 col-lg-6">
                    <label data-v-a047eab6="" for="emailSubject" class="col-form-label">Email Subject</label>
                    <textarea  class="form-control" v-model="emailSubject" rows="4" maxlength="100"></textarea>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label data-v-a047eab6="" for="ccemail" class="col-form-label">Cc recipients</label>
                    <multiselect
                      v-model="emailCC"
                      placeholder="Select users"
                      label="firstName"
                      track-by="id"
                      :options="userList"
                      :multiple="true"
                      :limit="3"
                    ></multiselect>
                  </div>
              </div>
              <br>
              <wysiwyg v-model="emailContent" />
                  <!-- <div v-html="emailContent"></div> -->
              </div>
              <div v-if="!isEmailGenerated" style="text-align: center; display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;" >
                <img src="@/assets/img/vector/no-data.jpg" class="w-50 img-fluid" alt="Import" /><br>
                <h3>No Email Preview Available. Click the Generate button to create an email preview.</h3>
              </div>    
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
          </div>
        </div>
          
      </div>
      </div>
  </div>
  <ChangeOffer v-if="changeOfferModalOpen" v-bind:offerProp="selectedOffer" @close="showChangeOfferModal()" />
  </div>
</template>

  <script>
  import authService from "@/authService";
  import config from "@/config";
  import ChangeOffer from "./ChangeOfferModal.vue";
  import Swal from 'sweetalert2';

  export default {
      name: 'modal',
      components :{
        ChangeOffer
      },
      props: ['offerIds','offers','selectedFilter'],
      data() {
          return {
              loading : false,
              loadingInit : false,
              pdfUrl : "",
              pdfName : null,
              spread : "",
              customer : null,
              emailContent : "",
              isEmailGenerated : false,
              customerList : [],
              selectedCustomer : "",
              selectedCustomerEmail : "",
              customerOffers : [],
              customerEmailOptions : [],
              currentIndex: 0,
              savedFilters : [],
              emailSubject : "",
              emailCC : [],
              userList : [],
              changeOfferModalOpen : false,
              selectedOffer : false,
              manualEntries : [],
              deletedOfferList : [],
              alternateOfferList : []


          };
      },
      computed: {
        currentCustomer() {
          return this.customerOffers[this.currentIndex];
        },
        isFirstCustomer() {
          return this.currentIndex === 0;
        },
        isLastCustomer() {
          return this.currentIndex === this.customerOffers.length - 1;
        }
      },
      methods: {
        deleteManualEntri(removeIndex){
          this.manualEntries.splice(removeIndex, 1);
          this.emailContent = "";
          this.isEmailGenerated = false;

        },

        async addCusipOffer() {
            const { value } = await Swal.fire({
              title: "Add Offer",
              html: `
                <form>
                  <div class="form-row justify-content-center mt-4">
                    <div class="form-group col-md-8">
                      <input id="swal-cusip" maxlength="9" type="text" class="form-control" placeholder="Enter Cusip">
                    </div>
                    <div class="form-group col-md-8">
                      <input id="swal-qty" type="number" class="form-control" placeholder="Enter Qty">
                    </div>
                    <div class="form-group col-md-8">
                      <input id="swal-price" type="number" class="form-control" placeholder="Enter Price">
                    </div>
                  </div>  
                </form>
              `,
              showCancelButton: true,
              confirmButtonText: "Add Offer",
              focusConfirm: false,
              preConfirm: () => {
                const cusip = document.getElementById("swal-cusip").value;
                const qty = document.getElementById("swal-qty").value;
                const price = document.getElementById("swal-price").value;

                if (!cusip) {
                  Swal.showValidationMessage("Please enter cusip");
                  return false
                }
                if (cusip.length < 9) {
                  Swal.showValidationMessage("Enter 9 digit characters long  CUSIP");
                  return false;
                }
                if (!qty || isNaN(qty) || parseInt(qty) <= 0 || !Number.isInteger(Number(qty))) {
                  Swal.showValidationMessage("Quantity must be a positive integer");
                  return false;
                }
                if (!price || isNaN(price) || parseFloat(price) <= 0) {
                  Swal.showValidationMessage("Price must be a positive number");
                  return false;
                }

                return { cusip , qty , price};
              },
            });

            if (value) {
              this.addOffer(value.cusip, value.qty ,value.price );
            }
          //}
        },
        addOffer(cusip,qty,price){
          this.manualEntries.push(
            {
                "cusip": cusip,
                "qty": Number(qty),
                "price": Number(price)
            }
          )
          this.emailContent = "";
          this.isEmailGenerated = false;
          
        },
        showChangeOfferModal(offer){
          console.log("C",offer)
          this.selectedOffer = offer
          this.changeOfferModalOpen = !this.changeOfferModalOpen;
        },
        deleteOffer(index){
          this.currentCustomer.customerOffers.splice(index,1);
          this.emailContent = "";
          this.isEmailGenerated = false;
        },
          customerSelected(){
            this.emailContent = "";
            this.isEmailGenerated = false;
            setTimeout(() => {
              this.customerEmailOptions = this.selectedCustomer.customerEmails;
              this.currentCustomer.customerid = this.selectedCustomer.id;
              if(this.customerEmailOptions.length == 1){
                this.selectedCustomerEmail = this.customerEmailOptions[0]
              }else{
                this.selectedCustomerEmail = ""
              }
            },100)
          },
          clearGeneratedEmail(){
            this.emailContent = "";
            this.isEmailGenerated = false;
          },
          clearFields(){
            if(!this.currentCustomer.isCustomerNotFound && this.currentCustomer.customerEmails.length == 1){
              this.selectedCustomerEmail = this.currentCustomer.customerEmails[0]
            }else{
              this.selectedCustomerEmail = ""
            }
            if(this.currentCustomer.isCustomerNotFound){
              this.selectedCustomer = "";
              this.selectedCustomerEmail = "";
            }
            this.emailContent = "";
            this.customerEmailOptions = [];
            this.isEmailGenerated = false;
            this.spread = "";
            this.emailSubject = "";
            this.emailCC = []
          },
          applySpread(){
            this.currentCustomer.customerOffers.forEach((offer) => {
              offer.spread = this.spread;
            })
            this.clearGeneratedEmail();
          },   
          nextCustomer() {
            // console.log("D")
            if (this.currentIndex < this.customerOffers.length - 1) this.currentIndex++;
            this.clearFields();
          },
          prevCustomer() {
            if (this.currentIndex > 0) this.currentIndex--;
            this.clearFields();
          },
          generateEmail(customer){
            this.loading = true;
            const auth = {
              headers: { 'org-token': authService.getOrgToken() }
            };
            let emailpost = {
                  "traderId": authService.getUser().id,
                  "customerId": customer.customerid,
                  "email": this.selectedCustomerEmail,
                  "manualEntries" : this.manualEntries,
                  "offeringEmailSpreadDtoList": customer.customerOffers
                      .filter((offer) => !offer.isIMSofferSelect)
                      .map((offer) => ({
                            offeringId: offer.id, 
                            spread: offer.spread 
                        })),
                  "imsOfferingEmailSpreadDtoList":customer.customerOffers
                    .filter((offer) => offer.isIMSofferSelect)
                    .map((offer) => ({
                              offeringId: offer.imsOfferId, 
                              spread: offer.spread 
                          })),
              }
            this.$http
              .post(
                config.baseUrlAutoBidder +
               `/offering-feed/email`,emailpost,
                auth
              )
              .then(response => {
                this.loading = false;
                if (response.data) {
                  this.emailContent = response.data.message;
                  this.emailSubject = response.data.subject;

                  this.deletedOfferList = response.data.deletedOfferList.concat(response.data.deletedOfferListIms || []);
                  this.alternateOfferList = response.data.alternateOfferList.concat(response.data.alternateOfferListIms || []);

                  this.isEmailGenerated = true;
                }          

              })
              .catch(() => {
                // console.log(e);
                this.isGenerateEmail = false;
                this.loading = false;

              });
          },
          sendToCustomer(customer){
              this.loading = true;
              const auth = {
                  headers: { 'org-token' : authService.getOrgToken()  }
              };
              console.log(typeof customer.matchedFilterNames)
              this.$http
              .post(config.baseUrlAutoBidder + "/offering-feed/email-send",
              {
                  "customerId": customer.customerid,
                  "traderId": authService.getUser().id,
                  "offeringIds": customer.customerOffers.filter((offer) => !offer.isIMSofferSelect).map((offer) => offer.id),
                  "emailContent": this.emailContent,
                  "filterIds": typeof customer.matchedFilterNames === 'string' ? customer.matchedFilterNames.split(',').map((name) => this.getFilterIdByFilterName(name)) : [], // Map filter names to IDs
                  "imsOfferingIds" : customer.customerOffers.filter((offer) => offer.isIMSofferSelect).map((offer) => offer.imsOfferId),
                  "emails" : [this.selectedCustomerEmail],
                  "filterNames" : typeof customer.matchedFilterNames === 'string'? customer.matchedFilterNames.split(',') : [],
                  "cusips" : customer.customerOffers.map((offer) => offer.cusip),
                  "subject" : this.emailSubject,
                  "ccEmails" : this.emailCC.map((user) => user.email),
                  "manualEntries" : this.manualEntries


                }, 
              auth)
              .then(() => {
                  this.loading = false; 
                  this.$alert("Email sent successfully ","","success");  
                  this.nextCustomer();  
                  if(this.isLastCustomer()){
                    this.$emit('close');               
                  }         
              })
              .catch(() => {
                  this.loading = false;              
              });
              
          },
          getUserList() {
            const auth = {
              headers: { "org-token": authService.getOrgToken() },
            };
            this.$http
              .get(
                config.baseUrlBidSide +
                  "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=",
                auth
              )
              .then((result) => {
                result.data.content.forEach((user) => {
                  user.isRestricted = false;
                  if(user.userGroups.length === 1){
                    if(user.userGroups[0] == "Drl-Client" || user.userGroups[0] == "Drl-Guest"){
                        user.isRestricted = true;
                    }
                  }
                });
                this.userList = result.data.content.filter(user => !user.isRestricted);
             
              })
              .catch(() => {
                // console.log(e);
              });
          },
          getCustomerList(){
            this.loadingInit = true;
            const auth = {
              headers: { 'org-token': authService.getOrgToken() }
            };
            
            this.$http
              .get(
                config.baseUrlAutoBidder +
                `/customer/name-list`,
                auth
              )
              .then(response => {
                this.customerList = response.data.map((data) => {
                    // Combine the name parts with spaces in between
                    data.customerFullName = `${data.customerFirstName || ''} ${data.customerMiddleName || ''} ${data.customerLastName || ''}`.trim();
                    return data;
                  });
                this.loadingInit = false;
                this.init()

                //customerFullName
              })
          },
          init() {
            console.log("offerids",this.offerIds)
            console.log("offers",this.offers)
            let deepCopyOffers = JSON.parse(JSON.stringify(this.offers));
            let offersFiltered = deepCopyOffers.filter(item => this.offerIds.includes(item.id));
            console.log("offersFiltered",offersFiltered)
            let customerMap = {};
            let unmatchedFilters = { isCustomerNotFound : true ,customerName: "NO CUSTOMER", customerid: null, customerOffers: [], matchedFilterNames: [] ,matchedFilterNamesArray : [] };
            // console.log(offersFiltered)
            offersFiltered.forEach((offer) => {
              offer.filterCustomersMap.forEach((filterObj) => {
                for (const [filterName, customers] of Object.entries(filterObj)) {
                  if (customers.length) {
                    customers.forEach((customer) => {
                      let key = `${customer.id}`;
                      if (!customerMap[key]) {
                        customerMap[key] = {
                          customerName: (customer.customerFirstName ? customer.customerFirstName[0] : "") +"."+ (customer.customerLastName ? customer.customerLastName : ""),
                          customerid: customer.id,
                          isCustomerNotFound : false,
                          matchedFilterNames: new Set(),
                          customerOffers: new Set(),
                          customerEmails : this.customerList.find((cust) => cust.id == customer.id ) ? this.customerList.find((cust) => cust.id == customer.id ).customerEmails : []
                        };
                        // console.log(this.customerList.find((cust) => cust.id == customer.id ))
                      }
                      customerMap[key].matchedFilterNames.add(filterName);
                      customerMap[key].customerOffers.add(offer);
                    });
                  } else {
                    // unmatchedFilters.matchedFilterNames.push(filterName);
                    // unmatchedFilters.customerOffers.push(offer);
                  }
                  //All Offers with 
                  unmatchedFilters.matchedFilterNames.push(filterName);
                  unmatchedFilters.customerOffers.push(offer);

                }
              });
              if(offer.filterCustomersMap.length == 0){
                unmatchedFilters.customerOffers.push(offer);
              }
            });

            // Convert sets to strings and arrays for final output
            let result = Object.values(customerMap).map((customer) => ({
              customerName: customer.customerName,
              customerid: customer.customerid,
              matchedFilterNames: Array.from(customer.matchedFilterNames).join(","),
              matchedFilterNamesArray: Array.from(customer.matchedFilterNames),
              customerOffers: Array.from(customer.customerOffers),
              customerEmails: customer.customerEmails,
              isCustomerNotFound : false
            }));

             // Add unmatched filters
            if (unmatchedFilters.matchedFilterNames.length) {
              unmatchedFilters.matchedFilterNames = [...new Set(unmatchedFilters.matchedFilterNames)].join(",");
              unmatchedFilters.matchedFilterNamesArray =  unmatchedFilters.matchedFilterNames,
              unmatchedFilters.customerOffers = [...new Set(unmatchedFilters.customerOffers)];
              result.push(unmatchedFilters);
            }
           
           if (this.selectedFilter) {
              // Prioritize matched filters
              let ordered = [
                ...result.filter(item => item.matchedFilterNames.includes(this.selectedFilter)),
                ...result.filter(item => !item.matchedFilterNames.includes(this.selectedFilter))
              ];

              // Move "NO CUSTOMER" record to the end
              result = [
                ...ordered.filter(item => item.customerName !== "NO CUSTOMER"),
                ...ordered.filter(item => item.customerName === "NO CUSTOMER")
              ];
            }
            this.customerOffers = result;
            console.log("final out",result)

            if(this.customerOffers.length && !this.customerOffers[0].isCustomerNotFound && this.customerOffers[0].customerEmails.length == 1){
              this.selectedCustomerEmail = this.customerOffers[0].customerEmails[0];
            }
            if(this.customerOffers.length == 0){
              this.customerOffers = [];
              this.customerOffers.push(unmatchedFilters)
            }

          },
          getSavedFilters(){
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlAutoBidder +
                "/offering-feed/filter-listall?page=1&size=100&search=&status=ACTIVE,INACTIVE&sortColumn=id&sortOrder=DESC" +
                "&userId="+
                authService.getUser().id+
                "&filterType=FILTER",
                auth
            )
            .then(result => {
              this.savedFilters = result.data.content;
            })
          },
          getFilterIdByFilterName(filterName) {
              const filter = this.savedFilters.find((filter) => filter.name === filterName);
              return filter ? filter.id : null; // Return `null` if no match is found
          }

              
      },
      created(){
        this.getCustomerList();
        this.getSavedFilters();
        this.getUserList(); 
      },
      mounted() {
        this.$root.$on("offerchange", (newOffer) => {
          //update offer
          let changeOfferId = newOffer.changeOfferId;
          this.currentCustomer.customerOffers.forEach((offer) => {
              if(offer.id == changeOfferId ){
                  if(newOffer.offerSource == 'IMS'){
                    offer.imsOfferId = newOffer.imsOfferId;
                    // offer.id = newOffer.id
                    offer.isIMSofferSelect = true;
                    offer.imsOfferPrice = newOffer.askPx;
                    offer.imsOfferQty = newOffer.askQty;
                    offer.imsOfferMinQty = newOffer.minQty;
                    // offer.spread = newOffer.spread;
                  }else{
                    offer.id = newOffer.id
                    offer.isIMSofferSelect = false;
                    offer.askPx = newOffer.askPx
                    offer.askQty = newOffer.askQty
                    offer.minQty = newOffer.minQty
                    // offer.spread = newOffer.spread
                    
                  }
              }
            })
            this.emailContent = "";
            this.isEmailGenerated = false;

        });
      },
      beforeDestroy() {
        this.$root.$off("offerchange");

      }

  };
  </script>
    <style scoped>
    .modal i {
      color: #fff;
      font-size: 11px;
      margin-right: 0px;
    }
    .form-group {
      margin: 10px;
    }
    .btn{
      border-radius: 5px !important;
    }
    .btn-outline-danger{
      background: #f5365c !important;
    }
    .multiselect{
      z-index: 9999 !important;
    }
    .multiselect__single{
      font-size: 11px !important;
    }
    .form-control {
      color :gray !important
    }
    .hint-color { 
      display: flex;
      flex-direction: row;
    }
    .hint-color div {
      text-align: left;
      font-size: 25px;
      font-weight: 900;
    }
    .hint-color .hint {
    padding: 5px;
    color: red
    }
    .hint-color i{
      color: #0087D4;
      font-size: 17px;
    }
    .psticky {
      position: sticky;
      top: 0;
      z-index: 1;
      background-color: #fff;
    }
  </style>